import { getCanonicalPathname } from '@/lib/locale';

export const GOOGLE_ONE_TAP_PATHS = [
  '/',
  '/image-editor',
  '/image-generator',
  '/image-to-video',
  '/photo-to-animation',
  '/ai-video-editor',
  '/text-to-video',
  '/ai-video-extender',
  '/video-upscale',
  '/reference-to-video',
  '/image-upscale',
  '/image-stitch',
] as const;

type GoogleOneTapPath = (typeof GOOGLE_ONE_TAP_PATHS)[number];

const GOOGLE_ONE_TAP_WORKFLOW_BY_PATH: Record<GoogleOneTapPath, string> = {
  '/': 'homepage',
  '/image-editor': 'image-editor',
  '/image-generator': 'image-generator',
  '/image-to-video': 'image-to-video',
  '/photo-to-animation': 'photo-to-animation',
  '/ai-video-editor': 'video-editor',
  '/text-to-video': 'text-to-video',
  '/ai-video-extender': 'video-extender',
  '/video-upscale': 'video-upscale',
  '/reference-to-video': 'reference-to-video',
  '/image-upscale': 'image-upscale',
  '/image-stitch': 'image-stitch',
};

const GOOGLE_ONE_TAP_PATH_SET = new Set<string>(GOOGLE_ONE_TAP_PATHS);

export function isGoogleOneTapPath(pathname: string) {
  return GOOGLE_ONE_TAP_PATH_SET.has(getCanonicalPathname(pathname));
}

export function getGoogleOneTapWorkflow(pathname: string) {
  const canonicalPath = getCanonicalPathname(pathname) as GoogleOneTapPath;
  return GOOGLE_ONE_TAP_WORKFLOW_BY_PATH[canonicalPath];
}
